export default function HowWeWorkSection() {
  return (
    <section className="section-space bg-[#F8F6F3]">
      <div className="shell">
        <p className="eyebrow">How we work</p>
        <h2>Start with people. Build with purpose.</h2>
        <div className="process-grid">
          {[
            {
              title: "Listen",
              text: "Understand your goals, your community, and the practical challenges ahead.",
            },
            {
              title: "Prepare",
              text: "Identify the knowledge, skills, and specialist support needed to move forward.",
            },
            {
              title: "Connect",
              text: "Explore aligned relationships and agree on clear, realistic next steps.",
            },
          ].map((s, i) => (
            <div key={s.title}>
              <span className="pillar-number">0{i + 1}</span>
              <h3>{s.title}</h3>
              <p className="body-copy">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
